import type { PhoneNumber } from 'apis/numbers';

import NumberItem from './items/NumberItem';

type ListNumbersProps = {
  selectedFromNumber: any;
  dynamicTelephoneNumbersArray: Array<any>;
  changeFromNumber: (payload: any) => void;
  onToggle: (isOpen: boolean) => void;
};

const ListNumbers = ({
  selectedFromNumber,
  dynamicTelephoneNumbersArray,
  changeFromNumber,
  onToggle,
}: ListNumbersProps) => {
  const listNumber = (number: PhoneNumber, index: number) => {
    let className = '';
    let disabled = false;

    if (typeof number !== 'string' && number.outgoing_functionality === false) {
      disabled = true;
      className = 'disabled';
    }
    if (
      selectedFromNumber &&
      selectedFromNumber.e164_format === number.e164_format
    ) {
      className += ' active';
    }
    return (
      <NumberItem
        key={index}
        index={index}
        disabled={disabled}
        className={className}
        changeFromNumber={changeFromNumber}
        number={number}
      />
    );
  };

  return (
    <div className="flags">{dynamicTelephoneNumbersArray.map(listNumber)}</div>
  );
};

export default ListNumbers;
